import { ANNOTATION_TYPE } from '../../constants';
import { type AnnotationT } from '../../types';
import { getCuboidVertices } from '../annotations/cuboid/utils';
import { getEllipseVertices } from '../annotations/ellipse/utils';
import { getRectangleVertices } from '../annotations/rectangle/utils';
export const snapHintRadius = 10;
export const snapRadius = 5;
const findClosestPoint = (points: {
  x: Array<number>;
  y: Array<number>;
}, mousePos: [number, number]) => {
  if (points.x.length === 0) {
    return {
      pointX: null,
      pointY: null
    };
  }
  let closestPointX = points.x[0];
  let closestPointY = points.y[0];
  points.x.forEach(element => {
    // @ts-expect-error todo(ts-migration) TS18048 'closestPointX' is possibly 'undefined'.
    if (Math.abs(mousePos[0] - element) < Math.abs(mousePos[0] - closestPointX)) {
      closestPointX = element;
    }
  });
  points.y.forEach(element => {
    // @ts-expect-error todo(ts-migration) TS18048 'closestPointY' is possibly 'undefined'.
    if (Math.abs(mousePos[1] - element) < Math.abs(mousePos[1] - closestPointY)) {
      closestPointY = element;
    }
  });
  return {
    pointX: closestPointX,
    pointY: closestPointY
  };
};
export const getSnapHintPoint = (points: {
  x: Array<number>;
  y: Array<number>;
}, mousePos: [number, number]) => {
  const {
    pointX,
    pointY
  } = findClosestPoint(points, mousePos);
  return {
    pointX: pointX ? Math.abs(pointX - mousePos[0]) <= snapHintRadius ? pointX : null : null,
    pointY: pointY ? Math.abs(pointY - mousePos[1]) <= snapHintRadius ? pointY : null : null
  };
};
export const getSnapPoint = (points: {
  x: Array<number>;
  y: Array<number>;
}, mousePos: [number, number]) => {
  const {
    pointX,
    pointY
  } = findClosestPoint(points, mousePos);
  return {
    pointX: pointX ? Math.abs(pointX - mousePos[0]) <= snapRadius ? pointX : null : null,
    pointY: pointY ? Math.abs(pointY - mousePos[1]) <= snapRadius ? pointY : null : null
  };
};
export const getVertices = (annotation: AnnotationT) => {
  let vertices;
  switch (annotation.annotationType) {
    case ANNOTATION_TYPE.RECTANGLE:
      vertices = getRectangleVertices(annotation.data);
      break;
    case ANNOTATION_TYPE.ELLIPSE:
      vertices = getEllipseVertices(annotation.data);
      break;
    case ANNOTATION_TYPE.POLYGON:
      vertices = annotation.data.points.map<{
        point: [number, number];
      }>(point => ({
        point
      }));
      break;
    case ANNOTATION_TYPE.POLYLINE:
      vertices = annotation.data.points.map<{
        point: [number, number];
      }>(point => ({
        point
      }));
      break;
    case ANNOTATION_TYPE.CUBOID:
      vertices = getCuboidVertices(annotation);
      break;
    case ANNOTATION_TYPE.KEY_POINT:
      vertices = [{
        point: [annotation.data.x, annotation.data.y]
      }];
      break;
    default:
      vertices = [];
      break;
  }
  return vertices;
};